module.exports = __webpack_public_path__ + "img/jindu.5484ac6e.png";